import { render } from "./VueCheckbox.vue?vue&type=template&id=0d69d2ba&scoped=true"
import script from "./VueCheckbox.vue?vue&type=script&lang=js"
export * from "./VueCheckbox.vue?vue&type=script&lang=js"

import "./VueCheckbox.vue?vue&type=style&index=0&id=0d69d2ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d69d2ba"]])

export default __exports__